module.exports = __webpack_public_path__ + "img/Union-Berlin.4b558f72.png";